export default "__VITE_ASSET__DIBQrAO2__"